<template>
  <ion-card
    style="height: 95%"
    class="ion-no-padding"
    @click="goToAreaTematica()"
  >
    <ion-img :src="props.testata.image" />
    <ion-card-title
      class="ion-text-center ion-text-wrap ion-padding-bottom"
      color="tertiary"
    >
      {{ props.testata.name }}
    </ion-card-title>
  </ion-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUpdated } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { document } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { Testata } from '@/models/testata.model';

addIcons({
  document: document,
});

import {
  IonContent,
  IonButtons,
  IonMenuButton,
  IonMenuToggle,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonFabButton,
  IonFab,
  modalController,
  IonIcon,
  IonCardSubtitle,
  IonImg,
  IonLabel,
} from '@ionic/vue';

export default defineComponent({
  name: 'JnAreaTematicaCard',
  props: {
    testata: {
      type: Testata,
      required: true,
    },
  },
  components: {
    IonCard,
    //IonCardHeader,
    //IonCardSubtitle,
    IonCardTitle,
    //IonLabel,
    /* IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonMenuToggle,
    IonTitle,
    IonMenuButton,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonText,*/
    IonImg,
  },

  setup(props) {
    const router = useRouter();

    const goToAreaTematica = async () => {
      router.push('/main/aree-tematiche/' + props.testata.id);
    };

    return {
      props,
      goToAreaTematica,
    };
  },
});
</script>
